// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"245":"97c4a7bc","337":"5f4e2537"}[chunkId] + ".css";
};